import { useEffect, useState, useRef } from 'react'
import styles from './styles.module.css'
import InputIA from '../../../components/InputIA'
import { SelectRound } from '../../../components/Select/SelectRound'
import {
  BrandingService,
  BucketUploadService,
  EventMapService,
  FontService,
} from '../../../services'
import { motion } from 'framer-motion'
import WebFont from 'webfontloader'
import Loading from '../../../components/Loading'
import { notifyErrorCustom } from '../../../utils/notify'
import { PreviousPass } from '../../../components/PreviousPass'
import Lottie from 'lottie-react'
import lazyLoadingAnimation from '../../../assets/lottie/lazy-loading-animation.json'
import { fetchGoogleFonts } from '../../../services/googleFontsService'
import { useTranslation } from 'react-i18next'
import { FooterNaviBar } from '../../../components/FooterNaviBar'

const STEPS = {
  STEP_PASS_COLOR_PALETTE: 'StepColorPalette',
  STEP_PASS_LOGO: 'stepLogo',
}

function StepTypography({
  setStep,
  businessAccountData,
  font,
  setFont,
  changesStep,
}) {
  const [textIA, setTextIA] = useState('')
  const [textExemple, setTextExemple] = useState('')
  const [fontsOptions, setFontsOptions] = useState([])

  const [branding, setBranding] = useState()

  const [filesSelectedArray, setFilesSelectedArray] = useState([])

  const [loading, setLoading] = useState(false)

  const [googleFonts, setGoogleFonts] = useState([])
  const [fonts, setFonts] = useState([]) // State para guardar as fontes
  const [fontUrls, setFontUrls] = useState('') // State para guardar as fontes
  const [serif, setSerif] = useState('')
  const [eventMapData, setEventMapData] = useState('')

  const [visibleItems, setVisibleItems] = useState(20)
  const observerTarget = useRef(null)

  const storage = window.localStorage

  const { t } = useTranslation()

  const stepsArray = [
    {
      pass: '1º Passo',
      title: 'Nicho e Objetivo',
      current: true,
    },
    {
      pass: '2º Passo',
      title: 'Paleta de cores',
      current: true,
    },
    {
      pass: '3º Passo',
      title: 'Fontes',
      current: true,
    },
    {
      pass: '4º Passo',
      title: 'BPS',
      current: false,
    },
    {
      pass: '5º Passo',
      title: 'Tom de Voz',
      current: false,
    },
    {
      pass: '6º Passo',
      title: 'Objetivo',
      current: false,
    },
    {
      pass: '7º Passo',
      title: 'Logo',
      current: false,
    },
    {
      pass: '8º Passo',
      title: 'Imagem',
      current: false,
    },
    {
      pass: '9º Passo',
      title: 'Geração de Arte',
      current: false,
    },
    {
      pass: '10º Passo',
      title: 'Download',
      current: false,
    },
  ]

  // const fontList = [
  //   'Roboto',
  //   'Open Sans',
  //   'Lato',
  //   'Oswald',
  //   'Montserrat',
  //   // etc.
  // ];
  const [fontList, setFontList] = useState([])

  // useEffect(() => {
  //   WebFont.load({
  //     google: {
  //       families: fontList,
  //     },
  //   });
  // }, []);

  const getFonts = async () => {
    setLoading(true)
    const fontsData = await fetchGoogleFonts() // Chama a função do serviço

    let fontUrls = '' // Variável para concatenar os URLs das fontes

    // console.log('103 fontsData', fontsData)

    // Mapeia os dados e gera a string concatenada
    const mappedFonts = fontsData.map((element) => {
      let fontUrl = ''

      const { family, files, variants } = element

      variants.forEach((variant) => {
        // Pode ser '300', 'regular', '500', '600', '700', etc.
        // Transforme 'regular' em 400, ou extraia 'italic' se existir.
        let fontWeight =
          variant === 'regular' ? 400 : parseInt(variant, 10) || 400
        let fontStyle = 'normal'

        // Se fosse '700italic', por exemplo, separe o 'italic'.
        // (No seu caso, pode não ter itálico, mas é só pra ilustrar)
        if (variant.includes('italic')) {
          fontWeight = parseInt(variant, 10) || 400
          fontStyle = 'italic'
        }

        const fontUrl = files[variant] // URL da variante específica

        if (fontUrl) {
          fontUrls += `
            @font-face {
              font-family: '${family}';
              src: url('${fontUrl}') format('truetype');
              font-weight: ${fontWeight};
              font-style: ${fontStyle};
            }
          `
        }
      })

      return {
        family: element?.family,
        font: fontUrl, // Mantém a URL da fonte no estado
      }
    })

    setFontsOptions(
      fontsData.map((e) => ({
        label: e.family,
        value: e.family,
        category: e.category,
      }))
    )

    // Remove o último ";" se necessário
    fontUrls = fontUrls.slice(0, -1)
    //console.log('fontsData', fontsData)

    // Atualiza os estados
    setGoogleFonts(mappedFonts) // Atualiza o estado com o array de fontes
    setFontUrls(fontUrls) // Atualiza o estado com a string de URLs
    // console.log('fontUrls',fontUrls)
    setLoading(false)
  }

  const handleFonts = async () => {
    const { data } = await fetchGoogleFonts()

    // console.log('returnFonts', data)

    data.forEach((element) => {
      setGoogleFonts((prevFonts) => [
        ...prevFonts, // Mantém as fontes anteriores
        {
          family: element.family,
          //font: element?.files?.regular,
        }, // Adiciona a nova fonte
      ])
    })
  }
  // console.log('fontsOptions', fontsOptions)

  const handleNavigate = async (type) => {
    if (type === 'next') {
      if (font === '') {
        notifyErrorCustom(t('fast_publishing_choose_a_font_for_your_art'))
        return
      }
      //
      saveFont()
      setStep(STEPS.STEP_PASS_LOGO)
    } else {
      setStep(STEPS.STEP_PASS_COLOR_PALETTE)
    }
  }

  useEffect(() => {
    getFonts() // Executa a função ao carregar o componente

    // loadBrandin()
  }, [])

  useEffect(() => {
    // getFonts() // Executa a função ao carregar o componente

    loadBrandin()
  }, [fontsOptions])

  const loadBrandin = async () => {
    const { data } = await BrandingService.getAllBrandingByBusinessId(
      businessAccountData?.data?.uuid ?? businessAccountData?.data[0]?.uuid
    )

    if (data[0]?.fontTitleId) {
      const font = await FontService.textFontById(data[0]?.fontTitleId)

      const index = fontsOptions.findIndex(
        (item) => item.value === font?.data?.name
      )

      handleClickSetFont(index, fontsOptions[index])
    }

    setFont(font?.value)
    setBranding(data[0])
  }

  const [selectedFontIndex, setSelectedFontIndex] = useState(null) // Estado para armazenar o índice da fonte selecionada

  const handleFontClick = (index, font) => {
    setFont(font?.value)
    setSelectedFontIndex(index) // Atualiza o índice da fonte selecionada
  }

  const saveFont = async () => {
    const { data: dataFont } =
      await BucketUploadService.getGoogleFontsBucketByName(
        filesSelectedArray[0].name
      )

    const fontsToUpdate = await formatFonts(filesSelectedArray)

    const brandinId = branding.uuid

    delete branding.uuid
    delete branding.businessId
    delete branding.createdAt
    delete branding.updatedAt
    delete branding.deletedAt
    delete branding.fontsBase64

    const dataToSubmit = {
      ...branding,
      ...fontsToUpdate,
    }

    const brandingRet = await BrandingService.getAllBrandingByBusiness()

    console.log('brandingRet', brandingRet)

    const { responseStatus } = await BrandingService.putBranding(
      brandinId,
      dataToSubmit
    )

    const dataEvent = {
      event: 'param_typography_set',
      eventData: {
        fontType: eventMapData.category,
        fontName: eventMapData.value,
      },
    }
    //await registerEvent(dataEvent)

    //if (!brandingRet.data[0].fontTitleId) {
    // const dataEvenProgress = {
    //   event: 'parametrization_progress_updated',
    //   eventData: {
    //     step: 'Typography',
    //     percentComplete: '75%',
    //   },
    // }
    // await registerEvent(dataEvenProgress)
    //}
  }

  // const registerEvent = async (data) => {
  //   await EventMapService.postEventMap(data)
  // }

  const formatFonts = async (fonts) => {
    let fontsUploadObj = {}

    fontsUploadObj['fontSubtitleId'] = ''
    fontsUploadObj['fontSubtitleByUploaded'] = false
    fontsUploadObj['fontTitleId'] = ''
    fontsUploadObj['fontTitleByUploaded'] = false
    fontsUploadObj['fontTextId'] = ''
    fontsUploadObj['fontTextByUploaded'] = false

    for (const fonte of fonts) {
      const objToGetId = {
        name: fonte.name,
        data: fonte.fileDataBase64,
      }
      const { data } = await FontService.postExternalFontsGoogle(objToGetId)

      // if (fonte.selectedFontType?.value == 2) {
      fontsUploadObj['fontSubtitleId'] = data.uuid
      fontsUploadObj['fontSubtitleByUploaded'] = false
      // }

      // if (fonte.selectedFontType?.value == 1) {
      fontsUploadObj['fontTitleId'] = data.uuid
      fontsUploadObj['fontTitleByUploaded'] = false
      // }

      // if (fonte.selectedFontType?.value == 3) {
      fontsUploadObj['fontTextId'] = data.uuid
      fontsUploadObj['fontTextByUploaded'] = false
      // }
    }

    return fontsUploadObj
  }

  const handleChangeFilterParams = (selectedFilters) => {
    setSerif(selectedFilters.category)
  }

  // const loadFonts = async () => {
  //   setLoading(true)
  //   let googleFontsBucket = await BucketUploadService.getGoogleFontsBucket()

  //   setFontsOptions(
  //     googleFontsBucket.data.map((e) => ({ label: e.name, value: e.name }))
  //   )
  //   setLoading(false)
  // }

  const handleClickSetFont = (index, font) => {
    setFont(font?.value)
    setEventMapData(font)

    const fontArrray = []

    const dataArray = {
      fileDataBase64: font.value,
      isSystemFont: true,
      name: font.value,
      selectedFontType: {
        label: 'Título',
        value: 1,
      },
    }

    fontArrray.push(dataArray)

    setSelectedFontIndex(index)
    // const aux = fontArrray
    // //if (aux.length >= 3 || !font) return
    // aux.push({ ...font })

    // const fontFamilies = aux
    //   // .filter((font) => !font.isSystemFont)
    //   .map((font) => font.name)

    // if (fontFamilies.length > 0) {
    //   WebFont.load({
    //     google: {
    //       families: fontFamilies,
    //     },
    //   })
    // }
    setFilesSelectedArray(fontArrray)

    //renderSelectedFontOnDocument()

    // const filteredTypeOptions = fontTypeOptions.filter(
    //   (e) => e.value != selectedFontType.value
    // )
    // setFontTypeOptions(filteredTypeOptions)

    // setSelectedFont(undefined)
    // setSelectedFontType(undefined)
    // setSelectedFontItem(undefined)
    // setFontUpload(false)
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisibleItems((prev) => {
            const filteredLength = fontsOptions
              .filter((font) =>
                font?.label?.toLowerCase().includes(textIA.toLowerCase())
              )
              .filter((font) =>
                font?.category?.toLowerCase().includes(serif.toLowerCase())
              ).length

            // Só aumenta se ainda houver mais itens para mostrar
            return prev < filteredLength ? prev + 20 : prev
          })
        }
      },
      { threshold: 1.0 }
    )

    if (observerTarget.current) {
      observer.observe(observerTarget.current)
    }

    return () => {
      if (observerTarget.current) {
        observer.unobserve(observerTarget.current)
      }
    }
  }, [observerTarget, fontsOptions, textIA, serif])

  return (
    <>
      <style>{`${fontUrls}`}</style>
      {/* <Loading enable={loading} /> */}
      <motion.div
        initial={{ x: '100vw' }}
        animate={{ x: 0 }}
        exit={{ x: '-100vw' }}
        transition={{ type: 'tween', duration: 0.5 }}
        style={{
          width: '100%',
          // height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div className={styles.box_step}>
          {/* <PreviousPass steps={stepsArray}/> */}
          {/* <style>
            {importFont}
          </style> */}
          <div className={styles.box_page}>
            {/* <p style={{ margin: "0px" }}>
              {t("fast_publishing_typography_text")}
            </p> */}
            <h1 style={{ marginTop: '0px', fontSize: '45px', fontWeight: 500 }}>
              {t('fast_publishing_typography')}
            </h1>

            <div className={styles.box_content_page}>
              <div className={styles.box_input_search}>
                <InputIA
                  placeholder={t(
                    'fast_publishing_typography_name_font_placeholder'
                  )}
                  text={textIA}
                  setText={setTextIA}
                  setLoading={() => {}}
                  clickFunction={() => {}}
                  suggestions={false}
                />
              </div>

              <div className={styles.box_selects}>
                <input
                  value={textExemple}
                  onChange={(e) => setTextExemple(e.target.value)}
                  className={styles.input_label}
                  type="text"
                  placeholder={t(
                    'fast_publishing_typography_text_font_placeholder'
                  )}
                />
                <SelectRound
                  htmlFor="select"
                  placeholder={
                    serif
                      ? serif
                      : `${t(
                        'fast_publishing_typography_category_font_placeholder'
                      )}`
                  }
                  defaultSelected={{
                    label: `${t(
                      'fast_publishing_typography_category_font_placeholder'
                    )}`,
                    value: '',
                  }}
                  options={[
                    {
                      label: storage.i18nextLng == 'en' ? 'All' : 'Todos',
                      value: '',
                    },
                    { label: 'Sans Serif', value: 'sans-serif' },
                    { label: 'Serifa', value: 'serif' },
                  ]}
                  onSelectItem={(selected) => {
                    handleChangeFilterParams({ category: selected.value })
                  }}
                />
              </div>

              <div className={styles.container_box_font}>
                {loading && (
                  <div className={styles.box_example_image}>
                    <Lottie
                      animationData={lazyLoadingAnimation}
                      style={{ width: '100%', height: 100 }}
                      loop={true}
                      autoplay={true}
                    />
                  </div>
                )}
                {/* {console.log('495 fontsOptions', fontsOptions)}  */}
                {fontsOptions
                  .filter((font) =>
                    font?.label?.toLowerCase().includes(textIA.toLowerCase())
                  )
                  .filter((font) =>
                    serif
                      ? font?.category?.toLowerCase() === serif.toLowerCase()
                      : font?.category?.toLowerCase().includes('')
                  )
                  .slice(0, visibleItems) // Limita o número de itens mostrados
                  .map((font, index) => (
                    <div
                      // className={styles.box_font} key={index}
                      className={
                        index === selectedFontIndex
                          ? styles.box_font_select // Adiciona uma classe extra se for a fonte selecionada
                          : styles.box_font
                      }
                      key={index}
                      onClick={() => {
                        handleClickSetFont(index, font)
                        changesStep.current = true
                        // console.log('changesStep.current', changesStep.current)
                      }} // Atualiza o estado com o índice da fonte clicada
                    >
                      {/* {console.log('493 serif', serif, 'category', font?.category)} */}
                      <p
                        className={
                          index === selectedFontIndex
                            ? styles.font_title_text_selected
                            : styles.font_title_text
                        }
                        style={{ fontFamily: fontList[index] }}
                      >
                        {font.label}
                      </p>

                      <div
                        className={
                          index === selectedFontIndex
                            ? styles.box_font_select_text
                            : styles.box_font_text
                        }
                        style={{ fontFamily: font.label }}
                      >
                        <h1
                          className={styles.font_text}
                          style={{ fontFamily: font.label }}
                          //href="https://fonts.gstatic.com/s/abeezee/v22/esDR31xSG-6AGleN6tKukbcHCpE.ttf"
                        >
                          {textExemple ||
                            'Whereas disregard and contempt for human rights have resulted. Lorem Ipsum dolor it damet setinels'}
                        </h1>
                      </div>
                    </div>
                  ))}
                <div ref={observerTarget} />
              </div>
            </div>
          </div>
          {/* <div className={styles.box_button}>
            <button
              className={styles.back_button}
              onClick={() => handleNavigate('back')}
            >
              {t('back_buttom')}
            </button>
            <button
              className={styles.next_button}
              onClick={() => handleNavigate('next')}
            >
              {t('next_buttom')}
            </button>
          </div> */}
          <FooterNaviBar
            back={() => handleNavigate('back')}
            next={() => handleNavigate('next')}
          />
        </div>
      </motion.div>
    </>
  )
}

export default StepTypography
